import { render, staticRenderFns } from "./SwiperPaginationDots.vue?vue&type=template&id=28ba1e2f&scoped=true&"
import script from "./SwiperPaginationDots.vue?vue&type=script&lang=js&"
export * from "./SwiperPaginationDots.vue?vue&type=script&lang=js&"
import style0 from "./SwiperPaginationDots.vue?vue&type=style&index=0&id=28ba1e2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ba1e2f",
  null
  
)

export default component.exports